import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ProjectHoursBillingTypePicker,
  ProjectHoursBillingTypePickerProps,
} from '@work4all/components/lib/components/entity-picker/project-hours-billing-type-picker/ProjectHoursBillingTypePicker';

import { ProjectHoursBillingType } from '@work4all/models/lib/Enums/ProjectHoursBillingType.enum';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<
    ProjectHoursBillingTypePickerProps<false>,
    'multiple' | 'value' | 'onChange'
  > {
  error?: string;
  value: ProjectHoursBillingType;
  onChange: (value: ProjectHoursBillingType) => void;
  filterValues?: string[];
}

export const ProjectHoursBillingTypePickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { error, ...pickerProps } = props;
  const { value, onChange } = pickerProps;

  const { t } = useTranslation();

  const name = t(`PROJECT_HOURS_BILLING_TYPE.${value}`);

  return (
    <EntityPickerPopover
      picker={
        <ProjectHoursBillingTypePicker
          {...pickerProps}
          multiple={false}
          value={{ id: value, name: name }}
          onChange={(value) => onChange(value.id)}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        label={t('COMMON.OUTLINE')}
        error={error}
        value={name}
      />
    </EntityPickerPopover>
  );
});
